<template>
    <div class="sidebar-root absolute" id="sidebar">
        <transition name="fade">
            <div
                @click="toggleSidebar()"
                v-if="animIn"
                class="background absolute"
            />
        </transition>

        <transition name="slide">
            <div v-if="animIn" class="sidebar-content d-flex flex-column">
                <div
                    :class="['d-flex', negatePaddingTop && 'negatePaddingTop']"
                >
                    <div class="flex-fill"><slot name="top" /></div>
                    <IconBtn
                        class="mr-1"
                        style="color: #333; padding: 14px; z-index: 9999;"
                        @click="toggleSidebar()"
                        name="times"
                        size="lg"
                    />
                </div>
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
import LOGO from '~/config/LOGO.png';
import { setTimeout } from 'timers';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
    name: 'BaseSidebar',
    props: {
        value: Boolean, // Show sidebar
        negatePaddingTop: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        logo: LOGO,
        animIn: false,
        targetElement: null,
    }),
    mounted() {
        this.animIn = true;
        this.targetElement = document.getElementById('sidebar');
        disableBodyScroll(this.targetElement);

        this.$nextTick(() => {
            window.history.pushState('backPressedSidebar', null, null);
            window.history.pushState('dummy', null, null);
            window.addEventListener('popstate', this.toggleSidebar, {
                once: true,
            });
        });

        document.addEventListener('keyup', this.escListener);
    },
    destroyed() {
        enableBodyScroll(this.targetElement);

        document.removeEventListener('keyup', this.escListener);
    },
    methods: {
        escListener(event) {
            if (event.key === 'Escape') {
                this.toggleSidebar();
            }
        },
        toggleSidebar(event) {
            if (event) {
                if (event.state == 'backPressedSidebar') {
                    this.toggleSidebar();
                }
            } else {
                this.animIn = false;
                setTimeout(() => this.$emit('input', !this.$props.value), 400);
            }
        },
        // prevent(event) {
        //     event.preventDefault();
        //     event.stopPropagation();
        // },
    },
};
</script>

<style scoped>
.sidebar-root {
    overflow: hidden;
    z-index: 999999;
}

.negatePaddingTop {
    margin-bottom: -57.33px;
}

.absolute {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

.background {
    z-index: 10000;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
}

.sidebar-content {
    left: 20%;
    width: 80%;
    height: 100%;
    position: relative;
    background-color: rgb(255, 255, 255);
    z-index: 10001;
}

@media only screen and (max-width: 400px) {
    .sidebar-content {
        left: 0;
        width: 100%;
    }
}

.image-wrapper {
    height: 100%;
    max-width: 100px;
}
.image-wrapper > img {
    height: 100%;
    width: auto;
    object-fit: cover;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.5s;
}
.slide-enter,
.slide-leave-to {
    transform: translateX(200%);
}
.slide-enter-to,
.slide-leave {
    transform: translateX(0);
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s;
}
.fade-enter .fade-leave-to {
    background-color: transparent;
}
.fade-enter-to,
.fade-leave {
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
